<template>
	<el-drawer :title="cardTitle" :visible.sync="visible" @close='comStateClose' size="30%"
		:close-on-press-escape="false" id="comDrawer">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerItem">
					<div class="drawerItemL">名称</div>
					<el-input v-model="name" placeholder="请输入活动名称" size="small" style="width: 160px;"></el-input>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">最小累积金额</div>
					<el-input-number v-model="min_money" :min="0" size="small" style="width: 160px;"></el-input-number>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">最大累积金额</div>
					<el-input-number v-model="max_money" :min="0" size="small" style="width: 160px;"></el-input-number>
				</div>
				<div class="drawerItem">
					<div class="drawerItemL">购买折扣</div>
					<el-input placeholder="请输入折扣" v-model="discount" size="small" style="width: 160px;">
						<template slot="append">折</template>
					</el-input>
				</div>

			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="comStateClose">取消</div>
				<div class="btn" @click="handleSubmitClick">保存</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		props: {
			comState: { //显示状态
				default: false
			},
			navType: {
				default: 0
			},
			navData: {
				default () {
					return {}
				}
			},
		},
		data() {
			return {
				visible: true,
				name: '',
				min_money: 0,
				max_money: 0,
				discount: 0,
				cardTitle: '',
			}
		},
		mounted() {
			console.log('编辑', this.navData)
			if (this.navType == 1) {
				this.cardTitle = '新建活动'
			} else if (this.navType == 2) {
				this.cardTitle = '编辑活动'
				this.name = this.navData.name;
				this.min_money = this.navData.min_money;
				this.max_money = this.navData.max_money;
				this.discount = this.navData.discount;
			}
		},
		methods: {

			//保存
			handleSubmitClick() {
				if (this.name == '') {
					this.$message({
						type: 'error',
						message: '请输入名称'
					})
					return
				}
				if (this.discount == 0) {
					this.$message({
						type: 'error',
						message: '请输入折扣'
					})
					return
				}
				console.log(this.navData)
				let params = {
					name: this.name,
					min_money: this.min_money,
					max_money: this.max_money,
					discount: this.discount,
					remark:''
				};
				if (this.navType == 1) {
					this.$http.post(process.env.VUE_APP_Url6 + 'api/GiftCardActivity/Add', params).then(
						res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '已新建'
								})
								this.$emit("closeOn", {
									type: 'submit'
								});
							}
						})
				} else if (this.navType == 2) {
					params._id = this.navData._id
					this.$http.post(process.env.VUE_APP_Url6 + 'api/GiftCardActivity/Update', params).then(
						res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '已修改'
								})
								this.$emit("closeOn", {
									type: 'submit'
								});
							}
						})
				}
				

			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", {
					type: 'close'
				});
			},
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;

		.drawerViewT {
			height: calc(100% - 60px);
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			padding: 0 20px;

			.drawerItem {
				display: flex;
				align-items: center;
				margin-top: 20px;

				.drawerItemL {
					width: 100px;
					font-weight: bold;
					font-size: 14px;
					text-align: right;
					margin-right: 12px;
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #F58B2F;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #E3E3E3;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #666;
				cursor: pointer;
			}
		}
	}
</style>
